import Landing from '../../auth/components/Landing';

export default function SignInIndexPage() {
    return <Landing />;
}
